import PATH from "constants/path";
import TabHotNews from "features/News/components/Tab/TabHotNews";
import TabNews from "features/News/components/Tab/TabNews";
import React, { useState } from "react";
import { isAuthenticated } from "utils/common";
import { useSelector } from "react-redux";

function News() {
  const [isHotNews, setIsHotNews] = useState(true);

  const [currentPageNotices, setCurrentPageNotices] = useState(1);
  const [currentPageNews, setCurrentPageNews] = useState(1);

  const { notices } = useSelector((state) => state.notice);

  return (
    <div
      className={
        isAuthenticated()
          ? "w-80 py-0 py-md-3"
          : "container px-0 px-md-3 px-lg-0"
      }
    >
      <div className="fs-20 fs-sm-18 fw-600 sp-14 text-center py-3 py-md-4">
        お知らせ
      </div>
      {notices && (
        <div className="d-flex align-items-center position-relative text-grey">
          <ul className="tabs-news my-0 py-0 overflow-auto">
            <li
              className={`tab-item-news ${isHotNews ? "active" : ""}`}
              onClick={() => {
                setIsHotNews(true);
              }}
            >
              重要なお知らせ
            </li>
            <li
              className={`tab-item-news ${isHotNews ? "" : "active"}`}
              onClick={() => {
                setIsHotNews(false);
              }}
            >
              ニュース
            </li>
          </ul>
          <a href={PATH.TOP} className="btn-back">
            <i className="bi bi-chevron-left"></i>TOPに戻る
          </a>
        </div>
      )}

      {
        <div className="tabs-content-news">
          <TabHotNews
            isActive={isHotNews === true}
            currentPageNotices={currentPageNotices}
            setCurrentPageNotices={setCurrentPageNotices}
          />
          <TabNews
            isActive={isHotNews === false}
            currentPageNews={currentPageNews}
            setCurrentPageNews={setCurrentPageNews}
          />
        </div>
      }
    </div>
  );
}

export default News;
